// REMOVED: import iconecell from "../assets/icon.png"; 
import fivenov from "../assets/8th.png";
import clock from "../assets/clock.png";
import jugaad from "../assets/jugaadnew.png";

const experiences = [
  {
    title: "100 rupees dega",
    // company_name: "JUGAAD",
    icon: fivenov,
    iconBg: "black",
    // date: "25 October 2023",
    points: [
      "INR 100 rupees will be handed over to each participating team on 14th Feb,9 am.",
    ],
  },
  {
    title: "8 ghante mei paisa double",
    // company_name: "JUGAAD",
    icon: clock,
    iconBg: "black",
    //date: "Jan 2021 - Feb 2022",
    points: [
      "Participants have to apply JUGAADS to earn maximum profits from 100 rupees.",
      "Any you can do literally anything & everything.",
    ],
  },
  {
    title: "Paisa hi paisa hoga",
    //company_name: "",
    icon: jugaad,
    iconBg: "black",
    // date: "5 November 2023",
    points: [
      "And guess what ? These PROFITS* are all yours.",
      "Plus, you will get a chance to earn exciting prizes worth INR 50K.",
      "So what are you waiting for ? Get your pockets filled",
    ],
  },
];

export { experiences };